export default class clients {
  static GoogleMapsClient: GoogleMapsClient;
}

export class GoogleMapsClient {
  autocomplete(object: any): any;
  geocode(object: any): any;
  placeDetails(object: any): any;
}
